<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
          <i class="material-icons cusIconSize">&#xE7FD;</i>
          <span>Manage Regional Administrators</span>
        </p>
      </div>

      <!-- Add Edit form -->
      <div class="admManageExamBreadcumTitle">
        <p class="admManageExamBreadcumCls">
          <span>
            <a class="searchFormLink" [showUnSavedChangesAlert]="{ form: form, redirect: 'AdmManageRegionalAdmin'}">
              Search Regional Administrators</a> >
            <span class="addEditFormLink"> {{pageConfig.title}}</span>
          </span>
        </p>
      </div>
      <md-card>
        <md-card-header>
          <div class="admPageHeadingSec">
            <md-card-title>
              <div class="admPageHeading">
                <p>
                  <span>{{pageConfig.title}}</span>
                </p>
              </div>
            </md-card-title>
          </div>
        </md-card-header>

        <md-card-content>
          <form class="example-form" [formGroup]="form" novalidate>

            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="First Name" formControlName="firstName" maxlength="100">
                </md-form-field>
              </div>

            </div>
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Last Name" formControlName="lastName" maxlength="100">
                </md-form-field>
              </div>
            </div>
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput  placeholder="Email" formControlName="email" maxlength="100">
                </md-form-field>
                  <p class="validate" *ngIf="form.controls.email.value && form.controls.email.errors && form.controls.email.errors.pattern">Incorrect Email Format</p>
              </div>

            </div>

            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Phone" formControlName="contactNo" maxlength="20">
                </md-form-field>
                <p requiredField *ngIf="form.controls.contactNo.touched && form.controls.contactNo.errors && form.controls.contactNo.errors.required"></p>
                <p validatePhoneNumber *ngIf="form.controls.contactNo.touched && form.controls.contactNo.errors && form.controls.contactNo.errors.pattern"></p>
              </div>
            </div>
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Kerberos User Name" formControlName="rhId" maxlength="100">
                </md-form-field>
                <p requiredField *ngIf="form.controls.rhId.touched && form.controls.rhId.invalid"></p>
              </div>
            </div>
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Region" mdInput formControlName="regionId" [mdAutocomplete]="region" [showDropDown]="{model: 'region', scope : this }">
                  <md-autocomplete #region="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of (regionFilteredOptions | async)" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <p requiredField *ngIf="form.controls.regionId.touched && form.controls.regionId.invalid"></p>
              </div>
            </div>


            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-select placeholder="Approver" formControlName="isApprover">
                  <md-option *ngFor="let option of approverOptions" [value]="option">
                    {{ option}}
                  </md-option>
                </md-select>
                <p requiredField *ngIf="form.controls.isApprover.touched && form.controls.isApprover.invalid"></p>
              </div>
            </div>

            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-select placeholder="Approver Country" formControlName="approverCountryId" multiple>
                  <md-option *ngFor="let option of countryOptions" [value]="option">
                    {{ option.name }}
                  </md-option>
                </md-select>
                <p requiredField *ngIf="form.controls.approverCountryId.touched && form.controls.approverCountryId.invalid"></p>
              </div>
            </div>

          </form>
        </md-card-content>

        <md-card-actions>
          <div class="button-row">
            <button [disabled]="form.invalid || pageConfig.isSaveDisable || (form.controls.regionId.value && !form.controls.regionId.value.id)"
              md-raised-button class="glbAdminBtnCls1" (click)="onSave()">
              <img src="./assets/images/saveBtnIcon.png" alt="">SAVE</button>
            <button [disabled]="pageConfig.isEditDisable" md-raised-button class="glbAdminBtnCls1" (click)="onEdit()">
              <img src="./assets/images/editBtnIcon.png" alt="">EDIT</button>
            <button [disabled]="pageConfig.isRetireDisable" md-raised-button class="glbAdminBtnCls1" (click)="onChangeStatus(false)">RETIRE</button>
            <button [disabled]="this.id == 0 || !pageConfig.isRetireDisable" md-raised-button class="glbAdminBtnCls1" (click)="onChangeStatus(true)">ACTIVATE</button>
          </div>
        </md-card-actions>

      </md-card>
    </div>
  </div>
</section>


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-regional-admin/adm-update-regional-admin/adm-update-regional-admin.component.html